import React from 'react'
import {NavLink, Link} from 'react-router-dom';
import "./Navbar.css";

export const Navbar = () => { 
    return <nav>
            <Link to="/" style={{
                fontSize: '38px'}}
                className="Title">DoTell
            <br></br>
            <span style={{
                position: 'relative',
                fontSize: '20px',
                fontWeight: 'normal',
                paddingRight: '100px',
                top: '-10px',
                whiteSpace: 'nowrap'

            }}><i>Conversational Testing</i></span></Link>
             <ul style={{flexWrap: 'wrap'}}>
                <li><NavLink to="/">Home</NavLink></li>
                <li><NavLink to="/theory">Theory</NavLink></li>
                <li><NavLink to="/vsmultiple">vs Multiple Choice</NavLink></li>
                <li><NavLink to="/sampletests">Sample Tests</NavLink></li>                
                {/* <li><NavLink to="/itemsamples">Item Samples</NavLink></li> */}
                <li><NavLink to="/nextsteps">Next Steps</NavLink></li>
             </ul>
        </nav>
}